import { render, staticRenderFns } from "./Podesavanja.vue?vue&type=template&id=12123345&scoped=true"
import script from "./Podesavanja.vue?vue&type=script&lang=js"
export * from "./Podesavanja.vue?vue&type=script&lang=js"
import style0 from "./Podesavanja.vue?vue&type=style&index=0&id=12123345&prod&scoped=true&lang=css"
import style1 from "./Podesavanja.vue?vue&type=style&index=1&id=12123345&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12123345",
  null
  
)

export default component.exports